import React from 'react';
import http from '@/services/http';
import { ORDER_URL, SETTINGS_URL } from './urls';

class OrderController extends React.Component {
	// `args` may carry `limit`/`cursor`/`dateField` for cursor pagination — the
	// backend returns the old unpaginated shape when `limit` is absent, so the
	// normalized pagination fields below stay falsy against an old backend.
	getCompleted = async (cityId, args) => {
		// console.log("getCompleted", args);
		let data;

		try {
			const res = await http.get(`${ORDER_URL}completed-orders/${cityId || ''}`, args);
			// console.log("orderz", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		// http.js resolves transport errors to undefined instead of rejecting.
		if (!data || data.error) {
			return { error: true, code: data?.code };
		}

		return {
			completedOrders: data.completedOrders,
			hasMore: !!data.hasMore,
			nextCursor: data.nextCursor ?? null,
			dateField: data.dateField,
			totalCount: data.totalCount,
			aggregates: data.aggregates,
			totalPrice: data.totalPrice,
			thirdTimeAvg: data.thirdTimeAvg,
			totalFee: data.totalFee,
			totalShopFee: data.totalShopFee,
			deliverygas: data.deliverygas,
		};
	};

	getOrderRange = async (cityId, args) => {
		// console.log("getCompleted", args);
		let data;

		// console.log("args", args);
		// console.log(`${ORDER_URL}order-range/${cityId || ""}`);
		try {
			const res = await http.get(`${ORDER_URL}order-range/${cityId || ''}`, args);
			// console.log("orderz", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			days: data?.days,
		};
	};

	getOperationStatus = async cityId => {
		// console.log("getOperationStatus");
		let data;

		try {
			const res = await http.get(`${SETTINGS_URL}get-operation-status/${cityId || ''}`);
			// console.log("getOperationStatus res", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		if (!data) {
			return {
				error: true,
			};
		}

		// console.log("operation ", data);
		return {
			operating: data.operating,
			notOperatingReason: data.notOperatingReason,
			warningMessage: data.warningMessage,
		};
	};

	getDraft = async cityId => {
		// console.log("get active orders query", cityId);
		let data;

		try {
			const res = await http.get(`${ORDER_URL}draft-orders/${cityId || ''}`);
			// console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error,
			};
		}

		return {
			draftOrders: data?.draftOrders,
		};
	};

	getActive = async cityId => {
		// console.log("get active orders query", cityId);
		let data;

		try {
			const res = await http.get(`${ORDER_URL}active-orders/${cityId || ''}`);
			// console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error,
			};
		}

		return {
			activeOrders: data?.activeOrders,
		};
	};

	add = async order => {
		// console.log("--- ADD ORDER");
		let data;

		try {
			const res = await http.post(ORDER_URL, { order });
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		if (!data) {
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	createFromDraft = async id => {
		// console.log("--- ASSIGN ORDER CALL");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}create-from-draft`, {
				id,
			});
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	assignOrder = async (orderId, deliveryId, toWoltDrive) => {
		// console.log("--- ASSIGN ORDER CALL");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}assign/${orderId}`, {
				deliveryId,
				toWoltDrive,
			});
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	removeOrderDelivery = async orderId => {
		// console.log("--- ASSIGN ORDER CALL");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}remove-order-delivery/${orderId}`);
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	editLiveOrder = async (orderId, editedFields) => {
		// console.log("--- ASSIGN ORDER CALL");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}edit-live-order/${orderId}`, {
				editedFields,
			});
			// console.log("res from add", res);
			// The error interceptor resolves transport failures to undefined, so a
			// missing body is a failure, not an empty success.
			if (!res?.data) {
				return {
					error: true,
				};
			}
			data = res.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// minutes counts from now, not from the order's creation time.
	changeOrderDelay = async (orderId, minutes) => {
		let data;

		try {
			const res = await http.put(`${ORDER_URL}change-order-delay/${orderId}`, {
				minutes,
			});
			// The error interceptor resolves transport failures to undefined, so a
			// missing body is a failure, not an empty success.
			if (!res?.data) {
				return {
					error: true,
				};
			}
			data = res.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// makeOrderPending = async (orderId) => {
	//   // console.log("--- ASSIGN ORDER CALL");
	//   let data;

	//   try {
	//     const res = await http.put(`${ORDER_URL}make-order-pending/${orderId}`);
	//     // console.log("res from add", res);
	//     data = res?.data;
	//   } catch (error) {
	//     console.log(error);
	//     return {
	//       error: true,
	//     };
	//   }

	//   return {
	//     ...data,
	//   };
	// };

	// resendAssignmentNotification = async (orderId) => {
	//   // console.log("--- ASSIGN ORDER CALL");
	//   let data;

	//   try {
	//     const res = await http.put(`${ORDER_URL}resend-notification-assignment/${orderId}`);
	//     // console.log("res from add", res);
	//     data = res?.data;
	//   } catch (error) {
	//     console.log(error);
	//     return {
	//       error: true,
	//     };
	//   }

	//   return {
	//     ...data,
	//   };
	// };

	completeOrder = async (orderId, fee) => {
		// console.log("completeOrder");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}complete/${orderId}`, { fee });
			// console.log('res from put', res)
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	cancel = async args => {
		// console.log("completeOrder");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}cancel/`, args);
			// console.log('res from put', res)
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	cancelDraft = async args => {
		// console.log("completeOrder");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}cancel-draft/`, args);
			// console.log('res from put', res)
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	getShopFeeList = async shopId => {
		let data;

		try {
			const res = await http.get(`${ORDER_URL}get-shop-fee-list`, { shopId });
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		// console.log("data.activeOrders", data.activeOrders);

		return {
			feeList: data.feeList,
			shopFeeList: data.shopFeeList,
		};
	};

	// prices: optional { fee, shopFee } set together with the area (admins).
	updateCompletedOrderArea = async (orderId, area, prices = {}) => {
		// console.log("carryOrder");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}update-completed-order-area/${orderId}`, {
				area,
				...prices,
			});
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	updateCompletedOrderFee = async (orderId, fee) => {
		// console.log("carryOrder");
		let data;

		try {
			const res = await http.put(`${ORDER_URL}update-completed-order-fee/${orderId}`, {
				fee,
			});
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	updateCompletedOrderShopFee = async (orderId, shopFee) => {
		let data;

		try {
			const res = await http.put(`${ORDER_URL}update-completed-order-shop-fee/${orderId}`, {
				shopFee,
			});
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// Piece work: an admin corrects the pieces of a completed job; the server
	// re-prices the charge and returns { pieces, shopFee }.
	updateCompletedOrderPieces = async (orderId, pieces) => {
		try {
			const res = await http.put(`${ORDER_URL}update-completed-order-pieces/${orderId}`, {
				pieces,
			});
			return res?.data || { error: true };
		} catch (error) {
			console.log(error);
			return { error: true };
		}
	};

	delete = async orderId => {
		let data;

		try {
			// console.log(city)
			const res = await http.delete(`${ORDER_URL}delete-order/${orderId}`);
			data = res?.data;
			if (!res) {
				return {
					error: true,
				};
			}
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};
}

const orderController = new OrderController();

export default orderController;
